import React, { useCallback, useEffect, useRef } from 'react';
import LocalOpsSheet from './LocalOpsSheet';
import { formatJGK, getLocalOpsConfig } from '../../utils/localOpsConfig';
import BuyJGKToken from '../buyJGKToken/BuyJGKToken';

export default function LocalOpsTopUpSheet({
  open,
  onClose,
  presetAmount,
  returnTo,
  onCheckoutStart,
}) {
  const { jgkPerUsd } = getLocalOpsConfig();
  const rate = Number.isFinite(jgkPerUsd) ? jgkPerUsd : 1000;
  const rateLabel = formatJGK(rate);
  const checkoutCloseRef = useRef(false);

  useEffect(() => {
    if (open) {
      checkoutCloseRef.current = false;
    }
  }, [open]);

  const handleCheckout = useCallback(() => {
    if (checkoutCloseRef.current) return;
    checkoutCloseRef.current = true;
    onCheckoutStart?.();
    onClose?.();
  }, [onCheckoutStart, onClose]);

  return (
    <LocalOpsSheet open={open} onClose={onClose} title="Top up JGK Balance">
      <div className="localops-section">
        <div className="localops-helper">
          Top up once to reserve funds and keep your LocalOps flow moving.
        </div>
        <div className="localops-helper">
          JGK Balance is prepaid credit you can earn or top up.
        </div>
        <div className="localops-helper">
          Add JGK and you're back here instantly.
        </div>
        <div className="localops-helper">Current rate: {rateLabel} = $1</div>
        <div className="localops-helper">
          After topping up, you will return to your LocalOps step.
        </div>
        <div className="localops-helper">
          If payment closes or fails, you're still on this step. Try again.
        </div>
      </div>
      <div className="localops-topup-embed">
        <BuyJGKToken
          onCheckout={handleCheckout}
          presetAmount={presetAmount}
          returnTo={returnTo}
        />
      </div>
      <div className="localops-actions">
        <button
          type="button"
          className="localops-btn localops-btn--ghost"
          onClick={onClose}
        >
          Return to confirmation
        </button>
      </div>
    </LocalOpsSheet>
  );
}
